import React from 'react'

export default function RulesConfiguration() {
  return (
    <div>
      <h1>Rules Configuration Screen</h1>
    </div>
  )
}
